export default __webpack_public_path__ + "static/media/icon-instagram-white.c20eed05.svg";